export const QUICK_SHOP_SET_ACTIVE = 'QUICK_SHOP_SET_ACTIVE';
export const QUICK_SHOP_UPDATE_INDEX = 'QUICK_SHOP_UPDATE_INDEX';
